import React from "react";
import { Copy, Eraser, RotateCcw } from "lucide-react";
import { DayColumn, TimeAxis } from "./DayColumn";
import { DAYS, DAY_LABEL, DEFAULT_WEEKLY, cellsToWindows, windowsToCells, windowsLabel } from "./scheduleUtils";

// Weekly recurring schedule editor — operates on the unsaved `weekly` (windows per day) passed in.
export function WeeklyGrid({ weekly, onChange }) {
  const setDay = (d, cells) => onChange({ ...weekly, [d]: cellsToWindows(cells) });
  const copyMonday = () => onChange({ ...weekly, tue: weekly.mon, wed: weekly.mon, thu: weekly.mon, fri: weekly.mon });
  const copyMondayWeekend = () => onChange({ ...weekly, sat: weekly.mon, sun: weekly.mon });
  const clearDay = (d) => onChange({ ...weekly, [d]: [] });

  return (
    <div data-testid="weekly-grid">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <button type="button" onClick={copyMonday} data-testid="copy-monday" className="text-xs font-bold text-[#0A2540] border border-slate-200 rounded-full px-3 py-1 hover:bg-slate-50 inline-flex items-center gap-1"><Copy size={12} /> Copy Monday to Mon–Fri</button>
        <button type="button" onClick={copyMondayWeekend} data-testid="copy-monday-weekend" className="text-xs font-bold text-[#0A2540] border border-slate-200 rounded-full px-3 py-1 hover:bg-slate-50 inline-flex items-center gap-1"><Copy size={12} /> Copy Monday to Sat–Sun</button>
        <button type="button" onClick={() => onChange({ ...DEFAULT_WEEKLY })} data-testid="reset-default" className="text-xs font-bold text-slate-600 border border-slate-200 rounded-full px-3 py-1 hover:bg-slate-50 inline-flex items-center gap-1"><RotateCcw size={12} /> Reset to default</button>
        <span className="text-[11px] text-slate-400 ml-auto">Tap a cell, or drag to paint a range</span>
      </div>
      <div className="overflow-x-auto pb-2">
        <div className="flex gap-2 min-w-[640px]">
          <TimeAxis />
          {DAYS.map((d) => (
            <div key={d} className="flex-1 min-w-[72px]">
              <DayColumn dayKey={d} label={DAY_LABEL[d]} cells={windowsToCells(weekly[d])} onChange={(cells) => setDay(d, cells)} />
              <button type="button" onClick={() => clearDay(d)} data-testid={`clear-${d}`} aria-label={`Clear ${DAY_LABEL[d]}`}
                className="mt-2 w-full text-[10px] text-slate-400 hover:text-rose-600 inline-flex items-center justify-center gap-1"><Eraser size={10} /> Clear</button>
              <p className="mt-1 text-[10px] text-slate-500 text-center leading-tight" data-testid={`summary-${d}`}>{windowsLabel(weekly[d])}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
